module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/tv-pc-bg.89ac086b.png";